
export class ProcessBase {
businessUnitCode: string;
code: string;
domain: string;
visionCode: string;
}

